import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { ToastViewer } from '../../../../../components/common/text-viewer/ToastViewer';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { SecitionDivideLine } from './SecitionDivideLine';

interface ProductRecommendReasonSectionProps {
  product: IProduct;
}

export const ProductRecommendReasonSection = ({ product }: ProductRecommendReasonSectionProps) => {
  return (
    <>
      <Container>
        <InspectorCard>
          <InspectorCardHeader>
            <InspectorCardTitleWrap>
              <InspectorCardTitle>{'이 매물을 추천하는 이유'}</InspectorCardTitle>
            </InspectorCardTitleWrap>
            <InspectorCardIconWrap>
              <Icon name={'PluvaLogo'} width={18.78} height={4.57} />
            </InspectorCardIconWrap>
          </InspectorCardHeader>

          <InspectorCardContent>
            <InspectorCardContentWrap id={'inspector-contents'}>
              <ToastViewer content={product.content} />
            </InspectorCardContentWrap>
          </InspectorCardContent>
        </InspectorCard>
      </Container>

      <SecitionDivideLine />
    </>
  );
};

const Container = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const InspectorCard = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const InspectorCardHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  padding: var(--radius-medium, 8px) 24px;
  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px) var(--radius-medium, 8px) var(--radius-none, 0px) var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
`;

const InspectorCardTitleWrap = styled.div`
  height: 18px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
`;

const InspectorCardTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const InspectorCardIconWrap = styled.div`
  width: 32px;
  height: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 10px;

  flex-shrink: 0;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const InspectorCardContent = styled.div`
  width: 100%;
  display: flex;
  padding: var(--radius-medium, 8px) 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  border-radius: var(--radius-none, 0px) var(--radius-none, 0px) var(--radius-medium, 8px) var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const InspectorCardContentWrap = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;
